export enum Locale {
  en = 'en',
  de = 'de',
  es = 'es',
  it = 'it',
  pt = 'pt',
  nl = 'nl_NL',
  fr = 'fr-FR'
}

export enum IDAMLocale {
  de = 'de-DE',
  es = 'es-ES',
  it = 'it-IT',
  pt = 'pt-PT',
  nl = 'nl-NL',
  fr = 'fr-FR'
}

export const CURRENCY_PER_COUNTRY = {
  de: 'EUR',
  es: 'EUR',
  it: 'EUR',
  pt: 'EUR',
  nl: 'EUR',
  fr: 'EUR'
};
